<template>
    <VJoyDialog open>
        <template #dialog-header>
            <h2>Time travel</h2>
        </template>
        <template #dialog-body>
            <TimeTravelWidget />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {VJoyDialog} from '@maltjoy/core-vue';
    import TimeTravelWidget from '../../time-travel/TimeTravelWidget.vue';
</script>
